module.exports = __webpack_public_path__ + "img/status-eveywhere.fd39b3d4.png";